/**
 * @generated SignedSource<<cba19563d9141dbc669411c4460f16e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DevAiFlowPipelinesStatus = "FAILED" | "IN_PROGRESS" | "PROVISIONED" | "STARTING" | "STOPPED" | "%future added value";
export type codeFrame_loadFlowQuery$variables = {
  cloudId: string;
  sessionId: string;
};
export type codeFrame_loadFlowQuery$data = {
  readonly devai_flowSessionGetByIDAndCloudID: {
    readonly createdAt: string | null;
    readonly id: string;
    readonly issueARI: string | null;
    readonly pipelines: ReadonlyArray<{
      readonly status: DevAiFlowPipelinesStatus | null;
      readonly url: string | null;
    } | null> | null;
  } | null;
};
export type codeFrame_loadFlowQuery = {
  response: codeFrame_loadFlowQuery$data;
  variables: codeFrame_loadFlowQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "sessionId",
    "variableName": "sessionId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueARI",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "codeFrame_loadFlowQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DevAiFlowSession",
        "kind": "LinkedField",
        "name": "devai_flowSessionGetByIDAndCloudID",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DevAiFlowPipeline",
            "kind": "LinkedField",
            "name": "pipelines",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "codeFrame_loadFlowQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DevAiFlowSession",
        "kind": "LinkedField",
        "name": "devai_flowSessionGetByIDAndCloudID",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DevAiFlowPipeline",
            "kind": "LinkedField",
            "name": "pipelines",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6df7814c1c18a0e3bfbe3b0e7a4724ad",
    "id": null,
    "metadata": {},
    "name": "codeFrame_loadFlowQuery",
    "operationKind": "query",
    "text": "query codeFrame_loadFlowQuery(\n  $sessionId: ID!\n  $cloudId: ID!\n) {\n  devai_flowSessionGetByIDAndCloudID(sessionId: $sessionId, cloudId: $cloudId) @optIn(to: \"DevAiFlowSessionGetByIDAndCloudID\") {\n    id\n    createdAt\n    issueARI\n    pipelines {\n      status\n      url\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2bc96ac28bcd7ae80590b68d7d72c94d";

export default node;
